export class GroupReportHomework {
    title?: string;
    result?: number;

    static fromJson(fields: any): GroupReportHomework {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
